<template>
    <section>
        <div class="table-responsive">
            <div class="time-frame-switch float-left">
                <button type="button"
                        :class="selectedTimeFrame === day ? 'time-frame-switch-period-active' : ''"
                        class="time-frame-switch-period"
                        @click="selectedTimeFrame = day">
                    <translate translation-key="time.twentyFourHours"
                               fallback="24H" />
                </button>
                <button type="button"
                        :class="selectedTimeFrame === week ? 'time-frame-switch-period-active' : ''"
                        class="time-frame-switch-period"
                        @click="selectedTimeFrame = week">
                    <translate translation-key="time.sevenDays"
                               fallback="7D" />
                </button>
                <button type="button"
                        :class="selectedTimeFrame === month ? 'time-frame-switch-period-active' : ''"
                        class="time-frame-switch-period"
                        @click="selectedTimeFrame = month">
                    <translate translation-key="time.thirtyDays"
                               fallback="30D" />
                </button>
            </div>
        </div>
        <div class="row pt-4 pb-0">
            <slot :selected-time-frame="selectedTimeFrame" />
        </div>
    </section>
</template>

<script>
    import { day, week, month } from '../constants/timeframe';

    export default {
        name: 'DappStats',
        data() {
            return {
                selectedTimeFrame: day,
                day,
                week,
                month,
            };
        },
    };
</script>
